import React from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';

import { Container, Image } from '@uncinc/uncinc-react-kitchen-sink';

import { WebformWrapper, WysiwygField } from '../../../../components';
import WebformDate from '../../../../components/Webform/Date';
import WebformHidden from '../../../../components/Webform/Hidden';

import './style.scss';

const ParagraphCTAMijlpalen = ({ entity, fromMijlpalenTaxonomy }) => {
  const overriddenComponents = {
    hidden: WebformHidden,
    date: WebformDate,
  };

  const body = entity.getIn(['field_body', 0, 'processed']);
  const title = entity.getIn(['field_title', 0, 'value']);
  const webForm = entity.getIn(['field_webform', 0, 'target_id']);
  const imageUrl = entity.getIn(['field_media_image', 0, 'styles', '1_1'], null);
  const imageAlt = entity.getIn(['field_media_image', 0, 'alt'], '');
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkSecondaryTitle = entity.getIn(['field_secondary_link', 0, 'title']);
  const linkSecondaryUrl = entity.getIn(['field_secondary_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const variant = entity.getIn(['field_variant', 0, 'value'], '');

  return (
    <Container className="Paragraph ParagraphCTA ParagraphCTAMijlpalen">
      <div className="row">
        <div className={`col-12 ${fromMijlpalenTaxonomy ? 'col-lg-8 offset-lg-2' : ''}`}>
          <div className={`ParagraphCTAMijlpalen--variant--${variant} ParagraphCTAMijlpalen__inner`}>
            <div className="row">
              <div className="col-12 col-md-8">
                <div className="ParagraphCTAMijlpalen__body">
                  <h3 className="ParagraphCTAMijlpalen__textTitle">
                    {title}
                  </h3>

                  <WysiwygField
                    property="schema:text"
                    html={body}
                    className="ParagraphCTAMijlpalen__textBody"
                  />

                  {webForm && (
                    <div className="ParagraphCTAMijlpalen__webform">
                      <WebformWrapper id={webForm} overriddenComponents={overriddenComponents} />
                    </div>
                  )}

                  <div className="ParagraphCTAMijlpalen__buttons">
                    {linkUrl && (
                      <CoreLink className="Button Button--primary icon-after icon-arrow-right icon-variant-2" to={linkUrl}>{linkTitle}</CoreLink>
                    )}

                    {linkSecondaryTitle && (
                      <CoreLink to={linkSecondaryUrl} className="icon-after icon-chevron-right">
                        {linkSecondaryTitle}
                      </CoreLink>
                    )}
                  </div>

                </div>
              </div>
              {imageUrl && (
                <div className="col-12 col-md-4">
                  <div className="ParagraphCTAMijlpalen__imageWrapper">
                    <Image
                      className="ParagraphCTAMijlpalen__image"
                      src={imageUrl}
                      alt={imageAlt}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphCTAMijlpalen;
